<template>
  <div class="our detail">
     <p class="our_common_title">DKING【水龙头】意大利 FIR</p>
     <p class="detail_time">2017-01-01</p>
     <div class="detail_content">
       <img src="/static/images/m/core.jpg" alt="">
     </div>
  </div>
</template>

<script>
/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
export default {
  name: 'app',
  data(){
    return{
      cremq:false,
      cpcs:true
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){

  }
}
</script>

<style scoped>
.detail .our_common_title{
  font-size: 0.36rem;
  font-weight: bold;
  color: #000;
  padding:0.3rem 0.2rem 0.2rem;
}
.detail_time{
  font-size: 0.24rem;
  color: #555555;
  padding-left: 0.2rem;
  margin-bottom: 0.5rem;
}
.detail_content img{
  max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/detail.vue